var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78401 0.439745C10.0656 0.721678 10.2238 1.10385 10.2238 1.50232C10.2238 1.90078 10.0656 2.28296 9.78401 2.56489L4.33081 8.01809L9.78401 13.4713C10.0496 13.7563 10.1942 14.1333 10.1873 14.5229C10.1805 14.9124 10.0227 15.2841 9.74717 15.5596C9.47167 15.8351 9.1 15.9929 8.71046 15.9998C8.32091 16.0066 7.94391 15.862 7.65887 15.5964L1.1431 9.08066C0.861513 8.79873 0.70335 8.41656 0.70335 8.01809C0.70335 7.61963 0.861513 7.23745 1.1431 6.95552L7.65887 0.439745C7.9408 0.158162 8.32297 4.94787e-08 8.72144 3.91063e-08C9.1199 2.8734e-08 9.50208 0.158162 9.78401 0.439745Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon--arrow-left.94418e76521f2239e1508455902914c4.svg";
export { ForwardRef as ReactComponent };